import {
  LOGIN_USER,
  FORGOT_PWD,
  LOGOUT_USER,
  LOGGED_USER,
  SHOW_TOAST,
  SWITCH_USER,
  SWITCH_DATA
} from '@redux/types';

const INITIAL_STATE = {
  payload: null,
  login: null,
  loading: false,
  error: null,
  errorTime: null,
  authenticated: false,
  userId: '',
  dataSet: 'dataA'
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case LOGGED_USER.IN_PROGRESS:
      return {
        ...state,
        loading: true,
        authenticated: false
      };

    case LOGGED_USER.SUCCESS:
      return {
        ...state,
        // payload: action.payload,
        loading: false,
        authenticated: true
      };

    case LOGGED_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        authenticated: false
      };

    case LOGIN_USER.IN_PROGRESS:
      return {
        ...state,
        loading: true,
        authenticated: false
      };

    case LOGIN_USER.SUCCESS:
      return {
        ...state,
        payload: action.payload,
        loading: false,
        authenticated: true
      };

    case LOGIN_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FORGOT_PWD.IN_PROGRESS:
      return {
        ...state,
        loading: true
      };

    case FORGOT_PWD.SUCCESS:
      return {
        ...state,
        payload: action.payload,
        loading: false
      };

    case FORGOT_PWD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case LOGOUT_USER.IN_PROGRESS:
      return {
        ...state,
        loading: true
      };

    case LOGOUT_USER.SUCCESS:
      return {
        ...state,
        payload: action.payload,
        loading: false,
        authenticated: false
      };

    case LOGOUT_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case SHOW_TOAST:
      return {
        ...state,
        error: action.payload,
        errorTime: new Date().getTime()
      };
    case SWITCH_USER:
      return {
        ...state,
        userId: state.userId === 'investor' ? 'entrepreneur' : 'investor'
      };
    case SWITCH_DATA:
      return {
        ...state,
        dataSet: state.dataSet === 'dataA' ? 'dataB' : 'dataA'
      };
    default:
      return { ...state };
  }
};
